<div class="customer-favorites-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Favorites</span>

      <h1>Saved <span>Salons</span></h1>

      <p>
        Keep track of the salons that caught your eye, revisit your favorite
        locations, and quickly remove saved businesses you no longer need.
      </p>
    </div>

    <div class="hero-actions">
      <a routerLink="/customer" class="overview-btn overview-btn--dark">
        Discover Salons
      </a>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Favorites</span>
        <strong>{{ favouriteSalons.length }}</strong>
        <p>Saved salons currently attached to your customer profile.</p>
      </div>

      <img [src]="assetUrl + 'icons/favorite-red.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Reviewed</span>
        <strong>{{ reviewedFavorites }}</strong>
        <p>Saved salons with an available rating.</p>
      </div>

      <img [src]="assetUrl + 'icons/review-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Cities</span>
        <strong>{{ uniqueCitiesCount }}</strong>
        <p>Different cities represented in your saved list.</p>
      </div>

      <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Average Rating</span>
        <strong>{{ averageRating }}</strong>
        <p>Average visible rating across saved salons.</p>
      </div>

      <img [src]="assetUrl + 'icons/review-border.svg'" alt="" />
    </article>
  </section>

  <section class="metric-grid">
    <article class="metric-card">
      <span>Recently Saved</span>
      <strong>{{ recentlySavedCount }}</strong>
      <p>Favorites saved in the last 30 days.</p>
    </article>

    <article class="metric-card metric-card--success">
      <span>With Photos</span>
      <strong>{{ favoritesWithPhotos }}</strong>
      <p>Saved salons that have an image available.</p>
    </article>

    <article class="metric-card metric-card--warning">
      <span>Needs Details</span>
      <strong>{{ favoritesMissingDetails }}</strong>
      <p>Saved salons missing city, rating, or description.</p>
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Saved Businesses</span>
        <h2>Your Favorite Salons</h2>
        <p>
          Browse saved salons and remove any favorite directly from this list.
        </p>
      </div>

      <span class="count-pill">{{ favouriteSalons.length }} saved</span>
    </header>

    @if (!isLoading && favouriteSalons.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">
          <svg
            class="w-14 h-14"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
        </div>

        <strong>No favorite salons yet</strong>

        <p>
          Start exploring salons and add them to your favorites by clicking the
          heart icon. Your saved salons will appear here.
        </p>

        <a routerLink="/customer" class="overview-btn overview-btn--dark">
          Discover Salons
        </a>
      </div>
    } @else {
      <div class="favorites-list">
        @for (salon of favouriteSalons; track salon.id) {
          <article class="favorite-card">
            <img
              class="favorite-image"
              [src]="salon.image || assetUrl + 'img/mock-salon1.png'"
              [alt]="salon.salon_name"
              (error)="onImageError($event)"
            />

            <div class="favorite-info">
              <div class="favorite-title-row">
                <div>
                  <h3>{{ salon.salon_name || "Salon Name Not Available" }}</h3>

                  <p>
                    {{ salon.salon_description || "No description available." }}
                  </p>
                </div>

                <button
                  type="button"
                  class="favorite-heart"
                  (click)="toggleFavorite(salon.salon)"
                  [disabled]="isLoading"
                  title="Remove from favorites"
                >
                  <img
                    [src]="assetUrl + 'icons/favorite-red.svg'"
                    alt="Remove from favorites"
                  />
                </button>
              </div>

              <div class="favorite-meta">
                <span>
                  <strong>★</strong>
                  {{ salon.rating || "0.0" }}
                </span>

                <span>
                  {{ salon.salon_city || "City not available" }}
                </span>

                <span> Saved {{ formatDate(salon.created_at) }} </span>
              </div>

              <div class="favorite-footer">
                <span class="location-text">
                  {{
                    salon.address || salon.salon_city || "No address available"
                  }}
                </span>

                <a
                  [routerLink]="['../salon/details', salon.salon]"
                  class="overview-btn overview-btn--dark"
                >
                  View Details
                </a>
              </div>
            </div>
          </article>
        }
      </div>
    }
  </section>
</div>
